import React, { Component, createRef } from "react";
import FJResourceCommon from 'fj-components/FJResourceView'
import styles from './FJResourcesTransitionCommon.module.less';
import FJTransitionPreview from "./FJTransitionPreview";
import FJConfig from "../../../config/FJConfig";
import FJImage from "fj-components/FJImage";
import FJPhotoAnimationManager from "../../../core/FJPhotoAnimationManager";

class FJResourcesPhotoAnimationCommon extends Component{

	constructor(props) {
		super(props);
		this.animation = FJPhotoAnimationManager[props.type || 'none'];
		this.state = {
			progress: -1,
		};
		this._resourceCommon = createRef();
		this.transitionRef = createRef();
	}

	_cursorPoint = null;  // 开始拖动时的鼠标位置
	_isDragStart = false; // 是否经历了开始拖动
	_cursorPointInCloneNode = null; // 拖动时鼠标相对于节点的位置
	_cloneNode = null;   // 跟随鼠标移动的节点
	_video = null;
	tips = null;

	/**
	 * 处理控制器选中事件
	 */
	handleSelect = () => {
		if (this.props.handleSelect) {
			this.props.handleSelect(this.props.transitionName);
		}
	};

	/**
	 * 处理控制器返回的progress信息
	 */
	handleProgress = (progress) => {
		this.setState({progress});
	};

	/**
	 * @description 点击添加
	 * @private
	 */
	_onAddClick = () => {
		if (this.props.onAddClick) {
			this.props.onAddClick(this.props.id, this.props.type);
		}
	};

	/**
	 * @description 选中
	 * @private
	 */
	_onMouseUp = () => {
		this.props.selectMedia(this.props.id, 2, 0);
	};


	/**
	 * @description 记录当前鼠标位置
	 * @param e
	 */
	_recordPoint = (e) => {
		this._cursorPoint = {
			x: e.clientX,
			y: e.clientY,
		}
	};

	render() {
		let {
			width,
			height,
			marginRight,
			marginBottom,
			isChoose,
			hasName, // 是否显示名称
			name,
			addIconToolTip,
			classes,
			allTooltip,
			toggleTooltip,
			oneTooltip,
			isSelect
		} = this.props;

		let {
			progress
		} = this.state

		return (
			<FJResourceCommon width={width}
												height={height}
												marginRight={marginRight}
												marginBottom={marginBottom}
												ref={this._resourceCommon}
												hasAddBtn={false}
												isCanShowHover
												isChoose={isChoose}
												hasName={hasName}
												name={name}
												fileText={name}
												onAddClick={this._onAddClick}
												onDrag={this._onDrag}
												onMouseUp={this._onMouseUp}
												onMouseEnter={this._onMouseEnter}
												onMouseLeave={this._onMouseLeave}
												addIconToolTip={addIconToolTip}
												classes={classes}
												allTooltip={allTooltip}
												toggleTooltip={toggleTooltip}
												oneTooltip={oneTooltip}
												className={styles.copy_outer_box}
												onMouseMove={this._onMouseMove}
			>
				<FJTransitionPreview
					handleProgress={this.handleProgress}
					handleSelect={this.handleSelect}
					defaultProgress={progress}
					isSelect={isSelect}
				>
					<div className={styles.c_preview_transition_animation} ref={this.transitionRef}>
						{
							progress === -1 ? (
								<>
									<FJImage imgAdapt='cover' url={FJConfig.photoAnimationImg} setImgLoadStatus={this._setImgLoadStatus} refreshClassName={classes.refresh} />
									{this.animation.indicate()}
								</>
							) : (
								<FJImage imgAdapt='cover' url={FJConfig.photoAnimationImg} setImgLoadStatus={this._setImgLoadStatus} refreshClassName={classes.refresh} style={this.animation.transition(progress)} className={styles.image}/>
							)
						}
					</div>
				</FJTransitionPreview>
			</FJResourceCommon>
		)
	}

}



export default FJResourcesPhotoAnimationCommon;